import { CachedImage } from '@common/ui/CachedImage';

import styles from './SuperlikeBadge.module.scss';

export type SuperlikeBadgeProps = {
  testId: string;
  text: string;
  /** m: the feed card (board 2.1); s: the Likes grid (board 2.3). */
  size?: 'm' | 's';
  className?: string;
};

/** The pink badge with the 3D heart: «Суперлайк вам», «Суперлайк». */
export const SuperlikeBadge = ({
  testId,
  text,
  size = 'm',
  className,
}: SuperlikeBadgeProps) => (
  <span
    className={`${styles.superlikeBadge} ${className ?? ''}`}
    data-size={size}
    data-test-id={testId}
  >
    <CachedImage
      testId={`${testId}-icon`}
      src="/icons/3d-icons/likes.png"
      alt=""
      blur="2px"
      className={styles.icon}
    />
    {text}
  </span>
);
